import React from 'react';
import { motion } from 'framer-motion';
const items = ['ENGLISH DIGITAL EDITION', '3 VOLUMES + 5 BONUSES', 'US$19 USD', 'DIGITAL ACCESS AFTER CHECKOUT'];
export function AnnouncementBar() {
  return <div className="sticky top-0 z-50 w-full border-y-2 border-amber-500 bg-[#ece4d4] text-emerald-900 shadow-[inset_0_-1px_0_#f6e7b8,inset_0_1px_0_#f6e7b8]" data-id="element-12" data-mp="jtbo5f0kr768">
      <div className="mx-auto max-w-7xl px-3 py-2.5 md:px-6" data-id="element-13" data-mp="et63wjwmwmy6">
        <p className="hidden items-center justify-center gap-3 text-xs font-medium tracking-wide md:flex" data-id="element-14" data-mp="9wp9j7yudccn">
          {items.map((item, index) => <React.Fragment key={item} data-id="element-15" data-mp="uzfdudkrzb6" data-mpi={index}>
              {index > 0 && <span className="text-amber-500" aria-hidden="true" data-id="element-16" data-mp="vr9t1vfrqzv">✦</span>}
              <span className={index === 2 ? 'rounded-full bg-amber-500 px-2.5 py-0.5 font-bold text-emerald-950' : ''} data-id="element-17" data-mp="3s2kcka5vny6i">
                {item}
              </span>
            </React.Fragment>)}
        </p>
        <div className="relative overflow-hidden md:hidden" data-id="element-18" data-mp="67qn1a19dh3y">
          <p className="sr-only" data-id="element-19" data-mp="6acrv1wrliih">{items.join(' · ')}</p>
          <motion.div aria-hidden="true" className="flex w-max items-center gap-4 whitespace-nowrap text-[11px] font-semibold" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 18,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-20" data-mp="aawom4dfek43">
            {[0, 1].map(copy => <React.Fragment key={copy} data-id="element-21" data-mp="oz9p9engkr4x">
                {items.map((item, index) => <React.Fragment key={item} data-id="element-22" data-mp="twjeouaul2sr" data-mpi={index}>
                    <span className={index === 2 ? 'font-bold text-amber-700' : ''} data-id="element-23" data-mp="f8y8usml8ph5">{item}</span>
                    <span className="text-amber-500" data-id="element-24" data-mp="k81dwd2kivp4">✦</span>
                  </React.Fragment>)}
              </React.Fragment>)}
          </motion.div>
        </div>
      </div>
    </div>;
}